import { Col, Divider, Modal, Row, Timeline } from "antd";
import { capitalizeFirstLetter } from "../../../../helpers/utility";
import ReviewForm from "./ReviewForm";
import useIsMobile from "../../../../hooks/useIsMobile";
import useTabletLayout from "../../../../hooks/useTabletLayout";
import { NURSE_IP_COMPACT_MODAL_WRAP } from "../InitialInspection/ClosePopup";
import "../InitialInspection/compactModal.css";

function ReviewData({
  setReviewModalStatus,
  reviewModalStatus,
  reviewFormItems,
  formData,
  getData,
  formType,
  data,
}) {
  const isMobile = useIsMobile();
  const isTablet = useTabletLayout();
  const historyCount = data?.length || 0;

  return (
    <Modal
      footer={false}
      title="Review Data"
      open={reviewModalStatus}
      onCancel={() => setReviewModalStatus(false)}
      centered={isMobile || isTablet}
      wrapClassName={
        isMobile || isTablet ? NURSE_IP_COMPACT_MODAL_WRAP : undefined
      }
      getContainer={() => document.body}
      width={
        isMobile || isTablet ? "min(720px, calc(100vw - 32px))" : undefined
      }
      destroyOnClose
      styles={
        isTablet
          ? {
              body: {
                maxHeight: "calc(100vh - 180px)",
                overflowY: "auto",
                overflowX: "hidden",
              },
            }
          : undefined
      }
    >
      <Row gutter={[24, 24]}>
        <Col span={24} style={{ marginTop: isMobile ? 8 : 20 }}>
          {formData !== undefined && formData?.action !== "stop" && (
            <ReviewForm
              formData={formData}
              formType={formType}
              formItems={reviewFormItems}
              getData={getData}
            />
          )}
        </Col>
        <Divider orientation="left">History</Divider>
        <Col span={24}>
          <Timeline
            items={
              data
                ? data?.map((item) => ({
                    children: (
                      <>
                        <>
                          {item?.tube_aspiration &&
                            `Tube Aspiration - ${capitalizeFirstLetter(
                              item?.tube_aspiration
                            )}`}
                        </>
                        <br />
                        <>
                          {item?.position &&
                            `Position - ${capitalizeFirstLetter(
                              item?.position
                            )}`}
                        </>
                        <br />
                        <>
                          {item?.notes &&
                            `Notes - ${capitalizeFirstLetter(item?.notes)}`}
                        </>
                      </>
                    ),
                  }))
                : []
            }
            style={{
              maxHeight: historyCount > 4 ? "40vh" : "none",
              height: "auto",
              paddingTop: 10,
              overflow: historyCount > 4 ? "auto" : "visible",
            }}
          />
        </Col>
      </Row>
    </Modal>
  );
}

export default ReviewData;
